import { useState } from "react";
import { useIntl } from "react-intl";
import { resolveApiErrorMessage } from "../utils/apiErrors";

function useModalHook() {
	const { formatMessage: trans } = useIntl();
	const [showModal, setShowModal] = useState(false);
	const [customTittleText, setCustomTittleText] = useState(false);
	const [customMessageModal, setCustomMessageModal] = useState("");
	const [customCurrentItem, setCustomCurrentItem] = useState(false);
	const [showSuccessButton, setShowSuccessButton] = useState(true);
	const [isCreateNewItemAction, setIsCreateNewItemAction] = useState(false);
	const [deleteItemModal, setDeleteItemModal] = useState(false);
	const [showCustomFormModal, setShowCustomFormModal] = useState(false);
	const [successfullRequest, setSuccessfullRequest] = useState(false);
	const [cancelButtonText, setCancelButtonText] = useState("");
	const [sucessButtonText, setSucessButtonText] = useState("");

	const manageSuccessfullMesssage = (
		model,
		verb = "created",
		currentItemId = null,
	) => {
		setCustomCurrentItem(currentItemId);
		setSuccessfullRequest(true);
		setShowCustomFormModal(false);
		setCustomTittleText(trans({ id: verb, defaultMessage: verb }));
		setCustomMessageModal(trans({ id: "model_successfully_action", defaultMessage: "{model} successfully {action}" }, { model, action: trans({ id: verb, defaultMessage: verb }) }));
		setShowSuccessButton(false);
		setShowModal(true);
		setCancelButtonText(trans({ id: "close", defaultMessage: "Close" }));
		return false;
	};

	const manageResponseErrors = (
		errorMessage,
		model,
		verb = "creating",
		showTitle = false,
		customMessage = "",
	) => {
		setSuccessfullRequest(false);
		setShowCustomFormModal(false);
		if (!showTitle) {
			setCustomTittleText(trans({ id: "error_action_model", defaultMessage: "Error {action} {model}" }, { action: trans({ id: verb, defaultMessage: verb }), model }));
		} else {
			setCustomTittleText(customMessage);
		}
		setCustomMessageModal(errorMessage);
		setShowSuccessButton(false);
		setShowModal(true);
		setCancelButtonText(trans({ id: "close", defaultMessage: "Close" }));
		return false;
	};

	const prepareModalToCreateItem = () => {
		setIsCreateNewItemAction(true);
		setCustomTittleText(trans({ id: "item_does_not_exist", defaultMessage: "Item does not exist" }));
		setCustomMessageModal(trans({ id: "do_you_want_to_create_item", defaultMessage: "Do you want to create a new item?" }));
		setShowSuccessButton(true);
		setCancelButtonText(trans({ id: "no", defaultMessage: "No" }));
		setSucessButtonText(trans({ id: "yes", defaultMessage: "Yes" }));
		setShowModal(true);
	};

	const manageDeleteMessage = (model) => {
		setCustomTittleText(trans({ id: "delete_model", defaultMessage: "Delete {model}" }, { model }));
		setCustomMessageModal(trans({ id: "delete_model_confirmation", defaultMessage: "Are you sure you want to delete this {model}?" }, { model }));
		setCancelButtonText(trans({ id: "no", defaultMessage: "No" }));
		setSucessButtonText(trans({ id: "yes", defaultMessage: "Yes" }));
		setShowSuccessButton(true);
	};

	const manageResponse = (response, action, model) => {
		const data = response?.data;
		if (!data || data.status === true) return;

		manageResponseErrors(resolveApiErrorMessage(data, trans), model, action);
	};

	return {
		showModal,
		setShowModal,
		customTittleText,
		setCustomTittleText,
		customMessageModal,
		setCustomMessageModal,
		customCurrentItem,
		setCustomCurrentItem,
		showSuccessButton,
		setShowSuccessButton,
		manageResponseErrors,
		prepareModalToCreateItem,
		isCreateNewItemAction,
		setIsCreateNewItemAction,
		deleteItemModal,
		setDeleteItemModal,
		manageDeleteMessage,
		showCustomFormModal,
		setShowCustomFormModal,
		manageSuccessfullMesssage,
		successfullRequest,
		setSuccessfullRequest,
		manageResponse,
		cancelButtonText,
		setCancelButtonText,
		sucessButtonText,
		setSucessButtonText,
	};
}

export { useModalHook };
